export function getAnnotationStyles() {
	// pull from commonStyles if wanted here
	return {
		line: {
			color: '#000',
			lineDash: '1,0',
			width: 1.5
		},
		rectangle: {
			background: { color: null },
			color: null,
			top: { color: null },
			right: { color: null },
			bottom: { color: null },
			left: { color: null },
			lineDash: '1,0',
			width: 1.5
		},
		text: {
			color: '#777',
			font: {
				family: 'Arial',
				size: 12,
				weight: 'normal'
			},
			glow: {
				color: 'none',
				width: 2
			},
			padding: {
				bottom: 0,
				left: 0,
				right: 0,
				top: 0
			},
			textAlign: 'left',
			textBaseline: 'bottom'
		}
	};
}
